import { Autocomplete, Checkbox } from '@mui/material';
import React from 'react';
import { Box, Button, Stack, TextField } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const GlobalAutoCompleteMultiSelect = ({ options = {} }) => {
  const {
    formik = { values: {}, touched: {}, errors: {} },
    label = 'Multi Select',
    name = 'name',
    data = [],
    keys = { id: 'id', value: 'value' },
    sx = { width: '100%' },
  } = options;

  const handleFieldChange = (e, selectedOptions) => {
    const ids = selectedOptions?.map((s) => s[keys.id]);
    formik.setFieldValue(name, ids);
  };
  return (
    <Autocomplete
      fullWidth
      multiple
      disableCloseOnSelect
      sx={sx}
      name={name}
      options={data}
      getOptionLabel={(option) => option[keys.value] || ''}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        console.log({ key });

        return (
          <li key={props.id} {...optionProps}>
            <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
            {option[keys?.value || '']}
          </li>
        );
      }}
      value={data?.filter((f) => formik?.values[name].includes(f[keys?.id]))}
      onChange={handleFieldChange}
      renderInput={(params) => (
        <TextField
          disabled
          fullWidth
          autoComplete="off"
          {...params}
          label={label}
          error={formik.touched[name] && Boolean(formik.errors[name])}
          helperText={formik.touched[name] && formik.errors[name]}
        />
      )}
    />
  );
};

export default GlobalAutoCompleteMultiSelect;
